import { fetchData } from "../../utils/Http"
import { serverUrl } from "../../utils/Settings"

type Response = Hotelstouch.WebApp.WebShop.Api.ProductList.Response

export async function getProductList():Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/productList`)
}